import React, { useContext, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useLogOut } from "../../services/api/services";
import LoadingPanel from "../../components/LoadingPanel";
import { destroyToken } from "../../services/api/AxiosInterceptor";
import { BaseAppContext } from "../../utils/context";

function LogOut() {
  const [logoutState, logout] = useLogOut();
  const { clearContext } = useContext(BaseAppContext);

  useEffect(() => {
    logout();
  }, []);

  useEffect(() => {
    if (logoutState.data?.status === 0) {
      destroyToken();
      localStorage.clear();
      clearContext(); 
      window.location.href = "/";
    }
  }, [logoutState.data]);

  return (
    <>
      {logoutState?.loading && (
        <LoadingPanel fullScreen message="Logging Out..." />
      )}
    </>
  );
}
export default LogOut;
